import { timeLabels2Times } from './timeLabels2Times';

/**
 * 本地选择的时间范围转化为后端需要的对象结构
 */
const transFormTimeRange2Obj = (daysOfWeek?: number[], times?: string[]): Record<number, string[]> | undefined => {
  // 只有时间没有周，填充所有周
  if (!daysOfWeek?.length && times?.length) {
    return Array.from({ length: 7 }, (_, i) => i + 1).reduce((v, p) => {
      return {
        ...v,
        [p]: timeLabels2Times(times),
      };
    }, {});
  }
  return daysOfWeek
    ?.map((d) => (d === 0 ? 7 : d))
    ?.reduce((v, p) => {
      return {
        ...v,
        [p]: timeLabels2Times(times),
      };
    }, {});
};

export { transFormTimeRange2Obj };
